import { api } from "jiffy-api";
import { useQueries } from "@tanstack/react-query";
import { objNamesToCamelCase } from "common/utils/helpers/cases";
import { transformPrintOnDemandIds } from "@design-lab/shared/lib/misc";
import { useIsSample } from "@design-lab/shared/lib/config";

export function usePrintOnDemandProducts(
  productIds: string[],
  sampleOverride?: boolean,
  designLab: boolean = true
) {
  const isSampleFromContext = useIsSample();
  const isSample = sampleOverride !== undefined ? sampleOverride : isSampleFromContext;

  return useQueries({
    queries: productIds.map(productId => ({
      queryKey: [
        "product",
        productId,
        isSample ? "sample" : "regular",
        ...(designLab ? ["design_lab"] : [])
      ],
      queryFn: async () => {
        const product = await api.printOnDemand
          .getProduct(
            { catalog_number: productId },
            {
              ...(designLab ? { design_lab: "true" } : {}),
              ...(isSample ? { sample: "true" } : {})
            }
          )
          .then(objNamesToCamelCase)
          .then(transformPrintOnDemandIds);
        return product;
      },
      enabled: !!productId,
      staleTime: 5 * 60 * 1000
    }))
  });
}
